import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const Close = forwardRef<SVGSVGElement, Partial<IconProps>>(function Close({
  styles,
  ...props
}, ref) {
  return <Icon styles={styles} viewBox="0 0 24 24" title="close" description="close" ref={ref} {...props}>
        <path {...stylex.props([iconsStyles.neutralElement])} d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z" />
      </Icon>;
});